export default "__VITE_ASSET__9baa58e2__"